import { gql } from "@apollo/client";

// All ASSET_REMOVE events of an asset, newest first — the asset detail page's
// "Contamination Declarations" section derives its list from these, because
// the backend has no declaration list query.
export const AssetRemoveEvents = gql`
    query AssetRemoveEvents ($assetId: ID!, $limit: Int = 50) {
        installedBaseEventList (filter: { assetId: { equals: $assetId }, eventType: { equals: ASSET_REMOVE } }) {
            total
            installedBaseEvents (pagination: { limit: $limit }, sort: { insert: desc }) {
                id
                insert
                eventType
                user {
                    id
                    name
                }
                installedBaseNode {
                    id
                    pathNodes {
                        id
                        title
                    }
                }
            }
        }
    }
`;
